/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { MrfiktivFleetViewModelGen } from "./data-contracts";
import { HttpClient, RequestParams } from "./http-client";

export class FleetManager<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags Fleet Manager
   * @name FleetManagerControllerFindAllChildrenForFleet
   * @summary (FLEET-READ) Get a fleet and its children by fleet and partner id
   * @request GET:/partner/{partnerId}/fleet/{fleetId}/manager
   * @secure
   * @response `201` `(MrfiktivFleetViewModelGen)[]` Get a fleet tree by fleetId
   */
  fleetManagerControllerFindAllChildrenForFleet = (partnerId: string, fleetId: string, params: RequestParams = {}) =>
    this.http.request<MrfiktivFleetViewModelGen[], any>({
      path: `/partner/${partnerId}/fleet/${fleetId}/manager`,
      method: "GET",
      secure: true,
      format: "json",
      ...params
    });
}
